import run from '../../utilities/run';
import render from '../../utilities/render';
import ChangePasswordLogic from './changePasswordLogic.js';

// NOTE: make the target selector a place on the webpage where you want to import this
const targetSelector = "#change-password-container";

run(targetSelector, (outerEl)=>{
 attachHtml(outerEl);
});

function attachHtml(outerEl){
    const changePasswordLogic = new ChangePasswordLogic(outerEl);
    changePasswordLogic.init();
};





// WEBPACK FOOTER //
// ./src/pages/passwordGuidelines/changePasswordGuidelines.js